// CUB-144: SDK интерфейсов домена (артефакты `cbsui`) для legacy-фронта — тот же словарь и тот же
// протокол, что у песочницы продукта (frontend react-product: src/lib/uiSdk.ts). Одна и та же страница
// работает в продукте, в чате ИИ (MCP Apps, CUB-146), в превью `cubus ui dev` (CUB-153) и здесь.
// Меняете словарь — меняйте во всех хостах.
//
// Это НЕ SDK старых HTML-страниц (`cubusPageSdk.js`, getContext/query/save…): у тех свой протокол.

import { encodeFilter, isFilterShape } from '@/cubus/services/urlFilter'

export const UI_SDK_SOURCE = `
(function () {
  var pending = {};
  var seq = 0;
  var readyFns = [];

  function call(method, args) {
    return new Promise(function (resolve, reject) {
      var id = 'c' + (++seq);
      pending[id] = { resolve: resolve, reject: reject };
      parent.postMessage({ __cubus: true, id: id, method: method, args: args || {} }, '*');
      setTimeout(function () {
        if (pending[id]) { delete pending[id]; reject(new Error('Cubus: нет ответа на ' + method)); }
      }, 30000);
    });
  }

  window.addEventListener('message', function (e) {
    var d = e.data;
    if (!d || d.__cubus !== true) return;
    if (d.type === 'init') {
      window.cubus.user = d.user || null;
      window.cubus.params = d.params || {};
      var fns = readyFns; readyFns = []; window.cubus.__ready = true;
      fns.forEach(function (fn) { try { fn(); } catch (err) { console.error(err); } });
      return;
    }
    var p = pending[d.id];
    if (!p) return;
    delete pending[d.id];
    if (d.ok) p.resolve(d.result); else p.reject(new Error(d.error || 'Cubus: ошибка запроса'));
  });

  window.cubus = {
    user: null,
    params: {},
    __ready: false,
    ready: function (fn) { if (window.cubus.__ready) fn(); else readyFns.push(fn); },
    records: function (objectsid, opts) { return call('records', Object.assign({ objectsid: objectsid }, opts || {})); },
    record: function (objectsid, id) { return call('record', { objectsid: objectsid, id: id }); },
    save: function (objectsid, values) { return call('save', { objectsid: objectsid, values: values }); },
    remove: function (objectsid, id) { return call('remove', { objectsid: objectsid, id: id }); },
    objectFull: function (objectsid) { return call('objectFull', { objectsid: objectsid }); },
    refOptions: function (refid, q) { return call('refOptions', { refid: refid, q: q }); },
    aggregate: function (objectsid, opts) { return call('aggregate', Object.assign({ objectsid: objectsid }, opts || {})); },
    runProcedure: function (sid, params) { return call('runProcedure', { sid: sid, params: params || {} }); },
    startProcess: function (defId, slots) { return call('startProcess', { defId: defId, slots: slots || {} }); },
    logic: function () { return call('logic', {}); },
    navigate: function (target) { return call('navigate', target || {}); },
    submit: function (objectsid, values) { return call('submit', { objectsid: objectsid, values: values || {} }); },
    toast: function (text) { return call('toast', { text: String(text == null ? '' : text) }); },
  };

  var lastH = 0;
  function reportHeight() {
    var b = document.body; if (!b) return;
    var h = Math.ceil(b.scrollHeight);
    if (h > 0 && Math.abs(h - lastH) > 2) {
      lastH = h;
      parent.postMessage({ __cubus: true, type: 'height', height: h }, '*');
    }
  }
  window.addEventListener('load', reportHeight);
  setInterval(reportHeight, 500);

  window.addEventListener('error', function (e) {
    parent.postMessage({ __cubus: true, type: 'error', message: String(e.message || e) }, '*');
  });
})();
`

// Та же политика, что у песочницы продукта: сети нет, шрифты и библиотеки — Google Fonts и cdnjs.
const CSP = "default-src 'none'; "
  + "script-src 'unsafe-inline' https://cdnjs.cloudflare.com; "
  + "style-src 'unsafe-inline' https://fonts.googleapis.com https://cdnjs.cloudflare.com; "
  + 'img-src data: blob: https:; '
  + 'font-src data: https://fonts.gstatic.com https://cdnjs.cloudflare.com; '
  + "connect-src 'none'; form-action 'none'"

export function buildUiArtifactDoc(html) {
  const head = `<meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="${CSP}">`
    + '<meta name="viewport" content="width=device-width, initial-scale=1">'
    + `<script>${UI_SDK_SOURCE}</script>`
  const src = String(html || '')
  if (/<head[\s>]/i.test(src)) return src.replace(/<head([^>]*)>/i, (m, a) => `<head${a}>${head}`)
  if (/<html[\s>]/i.test(src)) return src.replace(/<html([^>]*)>/i, (m, a) => `<html${a}><head>${head}</head>`)
  return `<!doctype html><html><head>${head}</head><body>${src}</body></html>`
}

// CUB-1353: цель cubus.navigate → путь легаси. Поддерживается одна форма — {object, filter}: объект (sid или id)
// и, по желанию, отбор деревом фильтра ({isActive, node:{oper, conds, nodes}}), как в ?filter формы объекта.
// Произвольный path НЕ принимается: страница не должна уводить человека куда угодно от его имени.
// filterreset=1 вместе с отбором — «показать ровно это»: накопленный отбор формы (BUG-392) не подмешивается,
// иначе второй клик (февраль после января) сложил бы оба условия и показал пустой список.
export function navigatePath(target) {
  const t = target || {}
  if (t.path !== undefined) throw new Error('navigate: path не поддерживается — передайте {object, filter}')
  const obj = t.object === undefined || t.object === null ? '' : String(t.object).trim()
  if (!obj) throw new Error('navigate: не указан object')
  const base = `/cubus/object/${encodeURIComponent(obj)}`
  if (t.filter === undefined || t.filter === null) return base
  if (!isFilterShape(t.filter)) throw new Error('navigate: filter — дерево фильтра {isActive, node:{oper, conds, nodes}}')
  return `${base}?filter=${encodeFilter(t.filter)}&filterreset=1`
}

// where песочницы ({поле: значение} | {поле: {gte: 1}}) → плоский фильтр legacy-моста (buildFilter)
const WHERE_OPS = {
  eq: 'eq', ne: 'ne', gt: 'gt', lt: 'lt', gte: 'ge', lte: 'le',
}
export function whereToFlat(where) {
  if (!where) return null
  const flat = {}
  Object.keys(where).forEach(field => {
    const cond = where[field]
    if (cond !== null && typeof cond === 'object' && !Array.isArray(cond)) {
      const ops = Object.keys(cond)
      if (ops.length !== 1) throw new Error(`where.${field}: здесь одно условие на поле`)
      const op = ops[0]
      const v = cond[op]
      if (op === 'contains') flat[field] = { op: 'ilike', value: `%${v}%` }
      else if (op === 'startswith') flat[field] = { op: 'ilike', value: `${v}%` }
      else if (op === 'null') flat[field] = { op: v === false ? 'ne' : 'eq', value: null }
      else if (WHERE_OPS[op]) flat[field] = { op: WHERE_OPS[op], value: v }
      else throw new Error(`Оператор '${op}' не поддерживается: eq, ne, gt, lt, gte, lte, contains, startswith, null`)
    } else flat[field] = cond
  })
  return flat
}
